import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-info-box',
  templateUrl: './info-box.component.html',
  styleUrls: ['./info-box.component.css'],
})
export class InfoBoxComponent implements OnInit {
  @Input() title?: string;
  @Input() body?: string;
  @Input() list?: string[];
  @Input() removePadding: boolean = false;
  @Input() canDismiss: boolean = true;
  @Input() bgColor?: string;

  @Output() closeTapped: EventEmitter<any> = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}
}
